import React from "react";

import { Card, CardContent } from "../../components/ui/card";
import InfoTooltip from "../../components/ui/InfoTooltip";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import MultipleSelector from "../../components/ui/MultipleSelector";
import { Textarea } from "../../components/ui/textarea";

import { projectMetadataOptions } from "../../helpers/projectMetadataHelper";

const ProjectBasics = ({ properties, setProperties }) => {
  const updateProperties = async (field, value) => {
    const updatedProperties = {
      ...properties,
      [field]: value,
    };

    setProperties(updatedProperties);
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2 relative">
            <Label>
              Project types <span className="text-red-500">*</span>
            </Label>

            <div className="relative group">
              <InfoTooltip text="Required for project's context. Select or add custom project types that best describe your project. Multiple selections are allowed." />
            </div>
          </div>

          <MultipleSelector
            creatable
            defaultOptions={
              projectMetadataOptions.projectTypes.map((projectType) => {
                return { label: projectType, value: projectType };
              }) || []
            }
            value={
              properties.projectTypes.map((projectType) => {
                return { label: projectType, value: projectType };
              }) || []
            }
            onChange={(value) =>
              updateProperties(
                "projectTypes",
                value.map((x) => x.value)
              )
            }
            placeholder={
              properties.projectTypes.length > 0
                ? "Create custom project type..."
                : "Select or create project types..."
            }
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-2 relative">
            <Label>
              Project description <span className="text-red-500">*</span>
            </Label>

            <div className="relative group">
              <InfoTooltip text="Required for project's context. Provide a short detailed description of your project. This is required to generate context." />
            </div>
          </div>

          <Textarea
            value={properties.projectDescription}
            onChange={(e) =>
              updateProperties("projectDescription", e.target.value)
            }
            placeholder="Enter project description..."
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-2 relative">
            <Label>Project cost estimate</Label>

            <div className="relative group">
              <InfoTooltip text="Enter an estimated cost for your project. This will be used in later iterations for Cost benefit analysis." />
            </div>
          </div>

          <Input
            type="text"
            value={properties.projectCost}
            onChange={(e) => updateProperties("projectCost", e.target.value)}
            placeholder="Enter project cost estimate..."
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-2 relative">
            <Label>Project lifecycles</Label>

            <div className="relative group">
              <InfoTooltip text="Select the project lifecycles where the hazards are likely to occur." />
            </div>
          </div>

          <MultipleSelector
            creatable
            defaultOptions={
              projectMetadataOptions.lifecycles.map((lifecycle) => {
                return { label: lifecycle, value: lifecycle };
              }) || []
            }
            value={
              properties.projectLifecycles.map((lifecycle) => {
                return { label: lifecycle, value: lifecycle };
              }) || []
            }
            onChange={(value) =>
              updateProperties(
                "projectLifecycles",
                value.map((x) => x.value)
              )
            }
            placeholder={
              properties.projectLifecycles.length > 0
                ? "Create custom project lifecycle..."
                : "Select project lifecycles..."
            }
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectBasics;
